<template>
  <div class="float-button">
    <!-- <div class="row">
      <div class="col-12">
        <img src="//images/button-float-2.png">
      </div>
    </div> -->
    <!-- <div class="mobile-view">
        <span class="bg-white rounded-circle shadow mobile-help-center">
          <Link class="bg-gray-300 rounded"
              :class="isUrl('/loan/ok-loan') ? 'active' : ''"
              :href="route('information.faq.index', { lang: getLocale() })"
            >
            <div class="h-100 d-flex align-items-center justify-content-center">
              <img src="/images/question-svg.svg">
            </div>
            </Link>
        </span>
    </div> -->
    <div class="" style="position: relative; z-index: 10">
      <div
        @click="isShown = !isShown"
        id="help-center"
        :class="{ active: isShown }"
        class="position-fixed right-0 bottom-40 transform-custom"
      >
        <div class="d-flex">
          <div
            class="bg-red-ok-2 text-rl-mixed desktop-help-center text-white font-weight-light font-size-15 shadow cursor-pointer-ff-2"
            style="height: 10rem"
          >
            {{ __("Bantuan") }}
          </div>
          <div
            class="bg-white shadow p-4 font-weight-bold"
            style="width: 24rem; height: auto; min-height: 10rem"
          >
            <Link
              class="bg-gray-300 rounded text-decoration-none"
              :class="
                isUrl('/about/inverstory-relation/office-network')
                  ? 'active'
                  : ''
              "
              :href="
                route('about.investoryRelation.officeNetwork.index', {
                  lang: getLocale(),
                })
              "
            >
              <div class="bg-gray-300 rounded mb-3 p-2">
                <img
                  src="/images/phone.svg"
                  class="img-fluid px-4"
                  alt="question svg"
                /><span class="text-black">{{ __("Call Center") }}</span>
              </div>
            </Link>

            <Link
              class="bg-gray-300 rounded text-decoration-none"
              :class="isUrl('/loan/ok-loan') ? 'active' : ''"
              :href="route('information.faq.index', { lang: getLocale() })"
            >
              <div class="bg-gray-300 rounded mb-3 p-2">
                <img
                  src="/images/question-2.svg"
                  class="img-fluid px-4"
                  alt="question svg"
                /><span class="text-black">{{ __("FAQ") }}</span>
              </div>
            </Link>
           
            <Link
              class="bg-gray-300 rounded text-decoration-none"
              :href="route('wbs.index', { lang: getLocale() })"
            >
              <div class="bg-gray-300 rounded mb-3 p-2">
                <img
                  src="/images/wbs.svg"
                  class="img-fluid px-4"
                  alt="wbs icon"
                /><span class="text-black">{{ __("Whistle Blower System") }}</span>
              </div>
            </Link>

            

            <!-- <Link
              class="bg-gray-300 rounded text-decoration-none"
              :class="isUrl('/wbs') ? 'active' : ''"
              :href="route('wbs.index', { lang: getLocale() })"
            >
              <div class="bg-gray-300 rounded mb-3 p-2">
                <img
                  src="/images/wbs.svg"
                  class="img-fluid px-4"
                  alt="wbs icon"
                /><span class="text-black">{{ __('Whistle Blower System') }}</span>
              </div>
            </Link> -->
            <!-- <a href="https://www.okbank.co.id/faq/2" style="text-decoration: none; color: #0a0a0a">
              <div class="bg-gray-300 rounded p-2">
                <img src="/images/question-2.svg" class="img-fluid px-4" alt="question">
                  {{ __('FAQ') }}
                </div>
            </a> -->
          </div>
        </div>
        <span
          class="bg-white rounded-circle shadow desktop-help-center-circle text-center align-middle cursor-pointer-ff-2"
        >
          <div class="h-100 d-flex align-items-center justify-content-center">
            <img
              id="desktop-help-image"
              :src="isShown ? '/images/close.svg' : '/images/question-svg.svg'"
              alt="question svg"
            />
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShown: false,
    };
  },
  methods: {},
};
</script>

<style>
.transform-custom {
  transform: translateX(24rem);
  transition: transform 0.5s ease-in-out;
}

#help-center.active {
  transform: translateX(0);
}

.desktop-help-center {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  padding: 15px 10px 80px 10px;
  border-radius: 10px 0 0 30px;
}

.desktop-help-center-circle {
  position: absolute;
  /* top: 50%;
  left: -1.5rem; */
  /* transform: translateY(-50%); */
  /* width: 3rem; */
  /* height: 3rem; */
}
</style>
